"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getRemainingCookieTimeMinutes_1 = __importDefault(require("../utilities/getRemainingCookieTimeMinutes"));
var Cookies_1 = __importDefault(require("./Cookies"));
var setExpirationInLocalStorage_1 = __importDefault(require("../utilities/setExpirationInLocalStorage"));
var getExpirationInLocalStorage_1 = __importDefault(require("../utilities/getExpirationInLocalStorage"));
var CookieProvider = {
    get: function (name) {
        var value = Cookies_1.default.get(name);
        var expirationDate = getExpirationInLocalStorage_1.default(name);
        var remainingCookieTime = expirationDate && getRemainingCookieTimeMinutes_1.default(expirationDate);
        return {
            name: name,
            value: value,
            remainingCookieTime: remainingCookieTime
        };
    },
    set: function (_a) {
        var name = _a.name, value = _a.value, cacheMinutes = _a.cacheMinutes;
        Cookies_1.default.set(name, value || '', cacheMinutes || 0);
        if (cacheMinutes !== null) {
            setExpirationInLocalStorage_1.default(name, cacheMinutes);
        }
    }
};
exports.default = CookieProvider;
